/**
 * Thrown when vault limits block an operation; UI opens SubscriptionModal.
 */
export class UpgradeRequiredError extends Error {
  readonly reason: 'pets' | 'documents';

  constructor(reason: 'pets' | 'documents') {
    super('UPGRADE_REQUIRED');
    this.name = 'UpgradeRequiredError';
    this.reason = reason;
  }

  static is(err: unknown): err is UpgradeRequiredError {
    return err instanceof UpgradeRequiredError;
  }
}
